import { motion } from "framer-motion";
import { ArrowRight, Mail, MapPin, MessageCircle } from "lucide-react";
import { CONTACT } from "../lib/data";

export const Contact = () => {
    const prefix = "//";
    return (
        <section id="contact" data-testid="contact-section" className="relative py-24 md:py-40 overflow-hidden">
            <div className="absolute inset-0 bg-grid opacity-30" />
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full bg-cyan-500/15 blur-[140px]" />

            <div className="relative max-w-5xl mx-auto px-6 md:px-10 text-center">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                >
                    <div className="text-xs font-bold uppercase tracking-[0.2em] text-cyan-400 mb-6">
                        {prefix} Let's build
                    </div>
                    <h2 className="text-5xl sm:text-7xl lg:text-8xl font-bold tracking-tighter leading-[0.9]">
                        Ready when{" "}
                        <span className="text-gradient-cyan">you are.</span>
                    </h2>
                    <p className="mt-8 text-lg md:text-xl text-slate-400 max-w-2xl mx-auto leading-relaxed">
                        Tell me about your business and I’ll help you plan a website that brings in more customers. No pressure — just a practical conversation.
                        <br />
                        <br />
                        <span className="text-gradient-cyan">Free 30-minute consultation • No obligation • Usually replies within 2 hours</span>
                    </p>

                    <div className="mt-12 flex flex-wrap items-center justify-center gap-4">
                        <a
                            data-testid="contact-cta-calendly"
                            href='https://calendly.com/rsdwebstudio/30min'
                            target="_blank"
                            rel="noopener noreferrer"
                            className="group inline-flex items-center gap-3 px-8 py-5 rounded-full bg-cyan-400 text-[#040814] font-bold text-lg hover:bg-cyan-300 transition-all hover:shadow-2xl hover:shadow-cyan-500/40"
                        >
                            <MessageCircle size={20} />
                            Book a free consultation
                            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
                        </a>
                        <a
                            data-testid="contact-cta-email"
                            href={`mailto:${CONTACT.email}?subject=Project enquiry from your website`}
                            className="group inline-flex items-center gap-3 px-8 py-5 rounded-full border border-white/15 text-white font-semibold text-lg hover:border-cyan-400/60 hover:bg-cyan-400/5 transition-all"
                        >
                            <Mail size={20} />
                            {CONTACT.email}
                        </a>
                    </div>

                    <div className="mt-12 inline-flex items-center gap-2 text-sm text-slate-500">
                        <MapPin size={14} />
                        {CONTACT.location}
                    </div>
                </motion.div>
            </div>
        </section>
    );
};
